/** @module CollectionBook/NewMCProductColor */
define([
   	"dojo/_base/declare",
	"csi/table/AggregateFrom"
], function(declare,AggregateFrom) {

	return declare(AggregateFrom, {
		getFormData: function() {
			// summary: add hook into form data to make nodes selectable if the nodes have been already selected if AllowDuplicateColorways is true
			var fd = this.inherited(arguments);
			var mcProductNode = this.getParent();
			if(mcProductNode) {
				var marketingCollectionNode = this.m_cache.getNode(mcProductNode.__Parent__);
				if (marketingCollectionNode && marketingCollectionNode.AllowDuplicateColorways) {
					fd.resetAggregations();
				}
			}
			return fd;
		}
 	});
});